import { React, useCallback, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import successTick from "../../../../assets/images/common/Success.gif";
import failed from "../../../../assets/images/common/failed.gif";


import Button from "../../../ui/Button";
import DropDown from '../../../../components/ui/DropDown';

import { useSelector, useDispatch } from 'react-redux';
import { getOrganizationList, assignAndUnAssign } from '../../../../store/actions/organizationActions';
import { getOrganizationByUser } from "../../../../store/actions/usersAction"
import apiEndpoints from "../../../../apiEndpoints.js";
import { getloggedInUserType } from "../../../../utils/util.js";

const ModifyOrganization = ({currentPageType, closeModifyOrgsModal, userDetails, customerDetails}) => {

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { userId } = useParams();

    const organizationListResponse = useSelector((state) => state.organization?.organizationList);
    const assignedorganizationListByUserResponse = useSelector((state) => state?.users.assignedorganizationListByUserResponse)
    const assignUnAssignResponse = useSelector((state) => state.organization?.assignUnAssignResponse)

    const [responseStatus, setResponseStatus] = useState(false);

    const [activeTab, setActiveTab] = useState('assign');

    const [organizationList, setOrganizationList] = useState([]);
    const [selectedOrganization, setSelectedOrganization] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [orgSearchValue, setOrgSearchValue] = useState(false);
    const [organizationSearchLoading, setOrganizationSearchLoading] = useState(false);
    const [organizationCurrentPage, setOrganizationCurrentPage] = useState(1);
    const [organizationPageLoading, setOrganizationPageLoading] = useState(false);
    const [organizationTotalPage, setOrganizationTotalPage] = useState(0);

    const [assignedOrganizationList, setAssignedOrganizationList] = useState([]);
    const [assignedOrgSearch, setAssignedOrgSearch] = useState("");
    const [assignedOrganizationSearchLoading, setAssignedOrganizationSearchLoading] = useState(false);
    const [assignedOrganizationCurrentPage, setAssignedOrganizationCurrentPage] = useState(1);
    const [assignedOrganizationPageLoading, setAssignedOrganizationPageLoading] = useState(false);
    const [assignedOrganizationTotalPage, setAssignedOrganizationTotalPage] = useState(0);

    
    const goBack = () => {
        setResponseStatus(false)
        setIsLoading(false)
        closeModifyOrgsModal()
    }

    const handleSelectDomain = (value) => {
        setSelectedOrganization(value)
    }

    const changeTab = (value) => {
        setSelectedOrganization([])
        setActiveTab(value)
    }

    const fetchOrganizationList = useCallback(()=>{
        if(getloggedInUserType() === "internal") {
            if(userDetails?.customer_detail?.customer_id) {
                const baseUrl = `&page=${organizationCurrentPage}&page_size=10&customer_id=${userDetails?.customer_detail?.customer_id}`;
                const queryParams = orgSearchValue ? `&query=${orgSearchValue}` : "";
                const url = `${baseUrl}${queryParams}`;
                dispatch(getOrganizationList(url));
            }
        } else if(getloggedInUserType() === "customer") {
            const baseUrl = `&page=${organizationCurrentPage}&page_size=10`;
            const queryParams = orgSearchValue ? `&query=${orgSearchValue}` : "";
            const url = `${baseUrl}${queryParams}`;
            dispatch(getOrganizationList(url));
        }        
    },[dispatch, orgSearchValue, userDetails, organizationCurrentPage])

    const fetchAssignedOrganizationList = useCallback(()=>{
        if(currentPageType === "usersDetails") {
            const baseUrl = `&page=${assignedOrganizationCurrentPage}&page_size=10&user_id=${userDetails?.user_id}`;
            const queryParams = assignedOrgSearch ? `&query=${assignedOrgSearch}` : "";
            const url = `${baseUrl}${queryParams}`;
            dispatch(getOrganizationByUser(url, "modify"))
        } else {
            const baseUrl = `&page=${assignedOrganizationCurrentPage}&page_size=10&customer_id=${customerDetails?.customer_id}`;
            const queryParams = assignedOrgSearch ? `&query=${assignedOrgSearch}` : "";
            const url = `${baseUrl}${queryParams}`;
            dispatch(getOrganizationByUser(url, "modify"))
        }        
    },[dispatch, customerDetails, userDetails, currentPageType, assignedOrgSearch, assignedOrganizationCurrentPage])

    const saveList = () => {
        const ids = selectedOrganization.map(data => data.id);
        const isAssign = activeTab === "assign";
        
        const obj = {
            user_id: userId,
            organization_ids: ids
        };
    
        const url = isAssign ? apiEndpoints.users.assignOrganizationTouser() : apiEndpoints.users.unAssignOrganizationToUser()
        setIsLoading(true)
        dispatch(assignAndUnAssign(url, obj));
    };

    useEffect(()=>{
        fetchOrganizationList()
    },[fetchOrganizationList, orgSearchValue])

    useEffect(()=>{
        fetchAssignedOrganizationList()
    },[fetchAssignedOrganizationList, assignedOrgSearch])

    useEffect(()=>{
        if(organizationListResponse != null) {
            setOrganizationSearchLoading(false)
            setOrganizationPageLoading(false)
            let newList = organizationListResponse?.results.map((data)=>{
                return {
                    id: data.organization_id,
                    name: data.name,
                    value: data.organization_id,
                    logo: data.logo,
                    label: data.name
                }
            })
            setOrganizationList((prevList) => {
                const uniqueList = [...prevList, ...newList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setOrganizationTotalPage(organizationListResponse?.meta?.total_pages)
        }
    },[organizationListResponse])

    useEffect(()=>{
        if(assignedorganizationListByUserResponse != null) {
            setAssignedOrganizationSearchLoading(false)
            setAssignedOrganizationPageLoading(false)
            let newList = assignedorganizationListByUserResponse?.results.map((data)=>{
                return {
                    id: data.organization_id,
                    name: data.name,
                    value: data.organization_id,
                    logo: data.logo,
                    label: data.name
                }
            })
            setAssignedOrganizationList((prevList) => {
                const uniqueList = [...prevList, ...newList].reduce((acc, item) => {
                    if (!acc.some(existingItem => existingItem.id === item.id)) {
                        acc.push(item);
                    }
                    return acc;
                }, []);
                return uniqueList; //Prevents duplicate additions, avoiding redundant state updates
            });
            setAssignedOrganizationTotalPage(assignedorganizationListByUserResponse?.meta?.total_pages)
        }
    },[assignedorganizationListByUserResponse])

    useEffect(()=>{
        if(assignUnAssignResponse !== null ) {
            setIsLoading(false)
            setResponseStatus(true)
        } else {
            setResponseStatus(false)
            setIsLoading(false)
        }
    },[assignUnAssignResponse])


    return (
        <div className="add-organization-container add-domain-container">
            {!responseStatus && <>
                <div className="modal-header mt-4">
                    <h2>Modify Organization</h2>
                </div>
                <div className="assign-tab-container d-flex rounded my-3">
                    <p className={`rounded text-center ${activeTab === "assign" ? "active" : ""}`} onClick={()=>changeTab('assign')}>{t('organizationDetailsPage.modify.assign')}</p>
                    <p className={`rounded text-center ${activeTab === "unAssign" ? "active" : ""}`} onClick={()=>changeTab("unAssign")}>{t('organizationDetailsPage.modify.unAssign')}</p>
                </div>
                <div className="add-organization-step-one mb-5">

                    {activeTab === "assign" && 
                        <DropDown
                            options={organizationList}
                            placeHolder='Please select Organization'
                            dropDownType={"modifyOrganization"}
                            onChange={(e) => handleSelectDomain(e)}
                            isSearchable = {true}
                            isMulti
                            searchType={"server"}
                            defaultSelectedValue={selectedOrganization}
                            updateSearchValue={(data)=>{
                                setOrganizationList([])
                                setOrganizationSearchLoading(true)
                                setOrgSearchValue(data)
                                setOrganizationCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                            }}
                            isSearchLoading={organizationSearchLoading}
                            onScrollEnd = {()=>{
                                if(!organizationPageLoading && (organizationTotalPage > organizationCurrentPage)) {
                                    setOrganizationPageLoading(true)
                                    setOrganizationCurrentPage((prevPage) => prevPage + 1)
                                }
                            }}
                            pageLoading={organizationPageLoading}                            
                        />
                    }
                    {activeTab === "unAssign" && 
                        <DropDown
                            options={assignedOrganizationList}
                            placeHolder='Please select Organization'
                            dropDownType={"modifyOrganization"}
                            onChange={(e) => handleSelectDomain(e)}
                            isSearchable = {true}
                            isMulti
                            searchType={"server"}
                            defaultSelectedValue={selectedOrganization}
                            updateSearchValue={(data)=>{
                                setAssignedOrganizationList([])
                                setAssignedOrganizationSearchLoading(true)
                                setAssignedOrgSearch(data)
                                setAssignedOrganizationCurrentPage((prevPage) => (prevPage !== 1 ? 1 : prevPage)); 
                            }}
                            isSearchLoading={assignedOrganizationSearchLoading}
                            onScrollEnd = {()=>{
                                if(!assignedOrganizationPageLoading && (assignedOrganizationTotalPage > assignedOrganizationCurrentPage)) {
                                    setAssignedOrganizationPageLoading(true)
                                    setAssignedOrganizationCurrentPage((prevPage) => prevPage + 1)
                                }
                            }}
                            pageLoading={assignedOrganizationPageLoading}
                        />
                    }
                </div>
                <div className="form-submit-btn-group mt-4">
                    <Button buttonText={"Cancel"} buttonType="secondary" buttonClicked={()=>{goBack()}}/>
                    {!isLoading && <Button buttonText={"Save"} buttonType="primary" buttonClicked={()=>{saveList()}} disableButton={selectedOrganization.length === 0} />}
                    {isLoading && <Button buttonText={"Loading..."} buttonType="primary" disableButton={true} />}
                </div>
            </>}
            {responseStatus && <>
                <div className="addOrg-success-container d-flex align-items-center flex-column">
                    {assignUnAssignResponse?.detail?.status === "success" && <>
                        <div className="mt-5">
                            <img src={successTick} alt="success" />
                        </div>
                        <h2 className="mb-4 mt-5">{assignUnAssignResponse?.detail?.description}</h2>
                    </>}
                    {assignUnAssignResponse?.status === "failed" && <div className="addOrg-success-container d-flex align-items-center flex-column">
                            <div className="mt-5">
                                <img src={failed} alt="failed" />
                            </div>
                            <h2 className="mb-4 mt-5 fs-4">{assignUnAssignResponse?.description}</h2>
                            </div>}
                    <div className="btn-container mt-5">
                        <Button buttonText={"Back to Main Page"} buttonType="primary" buttonClicked={()=>{goBack()}} />
                    </div>
                </div>
            </>}
        </div>
    )
}

export default ModifyOrganization;